<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('INDEX.evg_sku_label_material_information') || '辅料信息'"
      :visible="visible"
      direction="rtl"
      :size="1000"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <div class="choose-fabric__wrapper" v-if="visible">
          <div>
            {{
              $l('INDEX.evg_sku_label_basic_information_materials') ||
                '物料基本信息'
            }}
          </div>
          <el-form
            ref="form"
            :model="formData"
            label-width="120px"
            label-position="top"
            size="mini"
            :rules="rules"
            :disabled="disabled"
          >
            <el-row :gutter="10" class="mt-2">
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('INDEX.evg_sku_label_basic_information_materials') ||
                      '物料分类'
                  "
                  prop="materialCategoryCode"
                >
                  <el-cascader
                    :options="categoryTree"
                    :props="{
                      emitPath: false,
                      checkStrictly: false,
                      value: 'value',
                      label: 'label',
                    }"
                    ref="cascaderCategoryTreeRef"
                    v-model="formData.materialCategoryCode"
                    clearable
                    filterable
                    size="mini"
                    style="width: 100%"
                    :showAllLevels="false"
                    @change="onCategoryChange"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_materialCategoryCode') ||
                        '请选择物料分类'
                    "
                  >
                    <template slot-scope="{ node, data }">
                      <span>{{ data.label }}</span>
                      <span v-if="!node.isLeaf">
                        ({{ data.children.length }})
                      </span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('INDEX.evg_sku_label_materialNames') || '物料中文名称'
                  "
                  prop="materialName"
                >
                  <el-input
                    v-model="formData.materialName"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_materialName') ||
                        '请输入物料中文名称'
                    "
                    maxlength="50"
                    :readonly="disabled"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('INDEX.evg_sku_label_materialNameEns') || '物料英文名称'
                  "
                  prop="materialNameEn"
                >
                  <el-input
                    v-model="formData.materialNameEn"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_materialNameEn') ||
                        '请输入物料英文名称'
                    "
                    maxlength="50"
                    :readonly="disabled"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('INDEX.evg_sku_label_materialSpec') || '物料尺寸'"
                  prop="materialSpec"
                >
                  <el-input
                    v-model="formData.materialSpec"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_materialSpec') ||
                        '请输入物料尺寸'
                    "
                    maxlength="50"
                    :readonly="disabled"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('INDEX.evg_sku_label_isCommonMaterial') || '是否通用物料'
                  "
                  prop="isCommon"
                >
                  <el-select
                    v-model="formData.isCommon"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_isCommonMaterial') ||
                        '请选择是否通用物料'
                    "
                    filterable
                    clearable
                    style="width: 100%;"
                  >
                    <el-option value="Y" :label="$l('INDEX.YES') || '是'">
                    </el-option>
                    <el-option value="N" :label="$l('INDEX.NO') || '否'">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('INDEX.evg_sku_label_is_customerProvide') ||
                      '是否客户提供'
                  "
                  prop="isCustomerProvide"
                >
                  <el-select
                    v-model="formData.isCustomerProvide"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_iscustomerProvide') ||
                        '请选择是否客户提供'
                    "
                    filterable
                    clearable
                    style="width: 100%;"
                  >
                    <el-option value="Y" :label="$l('INDEX.YES') || '是'">
                    </el-option>
                    <el-option value="N" :label="$l('INDEX.NO') || '否'">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('INDEX.evg_sku_label_isSpecify') || '是否指定供应商'
                  "
                  prop="isSpecify"
                >
                  <el-select
                    v-model="formData.isSpecify"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_isSpecify') ||
                        '请选择是否指定供应商'
                    "
                    filterable
                    clearable
                    style="width: 100%;"
                  >
                    <el-option value="Y" :label="$l('INDEX.YES') || '是'">
                    </el-option>
                    <el-option value="N" :label="$l('INDEX.NO') || '否'">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('INDEX.evg_sku_label_supCode') || '供应商'"
                  prop="scmCode"
                >
                  <dict-select
                    size="mini"
                    clearable
                    filterable
                    v-model="formData.scmCode"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_supCode') || '请选择供应商'
                    "
                    url="/master/common/dict/scmCooperated"
                  ></dict-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  :label="$l('INDEX.evg_sku_label_baseQty') || '基础用量'"
                >
                  <el-input-number
                    v-model="formData.baseQty"
                    v-el-inputnumber-default0
                    :controls="false"
                    style="width: 100%"
                    :precision="0"
                    :min="1"
                    :max="10"
                    :placeholder="
                      $l('INDEX.evg_sku_placeholder_baseQty') || '请输入基础用量'
                    "
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  :label="$l('INDEX.evg_sku_label_materialUnit') || '数量单位'"
                >
                  <dict-select
                    v-model="formData.materialUnit"
                    url="/master/common/dict/biz"
                    :body="{ dictType: 'materialUnit' }"
                    :placeholder="$l('INDEX.evg_sku_placeholder_materialUnit') || '请选择数量单位'"
                    size="mini"
                    style="width: 100%"
                    filterable
                    clearable
                  ></dict-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('INDEX.evg_sku_label_materialRange') || '使用范围'"
                  prop="materialRange"
                >
                  <dict-select
                    v-model="formData.materialRange"
                    url="/sys/common/dict/system"
                    :body="{ dictType: 'materialRange' }"
                    :placeholder="$l('INDEX.evg_sku_placeholder_materialRange') || '请选择使用范围'"
                    size="mini"
                    style="width: 100%"
                    filterable
                    clearable
                  ></dict-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item :label="''">
                  <br />
                  {{
                    $l('INDEX.evg_sku_label_desc') ||
                      '说明：选择具体产品规格，代表在生产产品时所需使用的物料，需指定具体使用的规格产品'
                  }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <div class="choose-fabric__wrapper mt-1" v-show="isSpec">
          <SpecMaterialTable
            :evgSkuCode="evgSkuCode"
            :disabled="disabled"
            :evgSkuMaterialCode="evgSkuMaterialCode"
            ref="materialInfo"
          ></SpecMaterialTable>
        </div>

        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            style="width:100px"
            @click="save()"
            v-if="!disabled"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import SpecMaterialTable from '../spec-material-table'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'

export default {
  components: { SpecMaterialTable },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    evgSkuCode: { type: String, default: '' },
    evgSkuMaterialCode: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      fabricList: [],
      formData: {
        baseQty: 1,
        isCommon: 'N',
        isCustomerProvide: 'N',
        isSpecify: 'N',
      },
      categoryTree: [],
      masterCategoryParams: { parentCode: 'ABSHome' },
    }
  },
  computed: {
    isEmpty() {
      return !this.fabricList.length
    },
    isSpec() {
      return this.formData.materialRange == 'A'
    },
    rules() {
      return {
        materialCategoryCode: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_materialCategory') || '请选择物料分类',
            trigger: 'change',
          },
        ],
        materialName: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_materialName') || '请输入物料中文名称',
            trigger: 'blur',
          },
        ],
        materialNameEn: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_materialNameEn') || '请输入物料英文名称',
            trigger: 'blur',
          },
        ],
        materialSpec: [
          {
            required: true,
            message: this.$l('INDEX.rules_materialSpec') || '请输入物料尺寸',
            trigger: 'blur',
          },
        ],
        isCommon: [
          {
            required: true,
            message: this.$l('INDEX.rules_isCommon') || '请选择是否通用物料',
            trigger: 'change',
          },
        ],
        isCustomerProvide: [
          {
            required: true,
            message:
              this.$l('INDEX.rules_isCustomerProvide') || '请选择是否客户提供',
            trigger: 'change',
          },
        ],
        isSpecify: [
          {
            required: true,
            message: this.$l('INDEX.rules_isSpecify') || '请选择是否指定供应商',
            trigger: 'change',
          },
        ],
        materialRange: [
          {
            required: true,
            message: this.$l('INDEX.rules_materialRange') || '请选择使用范围',
            trigger: 'change',
          },
        ],
      }
    },
  },
  mounted() {
    this.getData()
    this.getTreeData()
  },
  methods: {
    getData() {
      if (!this.evgSkuMaterialCode) return
      this.$api
        .ecomEvgSkuMaterialDetailApi({
          evgSkuMaterialCode: this.evgSkuMaterialCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    getTreeData() {
      this.$api
        .ecomEvgSkuMaterialMaterialApi(this.masterCategoryParams)
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    onCategoryChange() {
      this.$nextTick(() => {
        const nodes = this.$refs.cascaderCategoryTreeRef.getCheckedNodes()
        if (nodes?.length && nodes[0] && nodes[0].path?.length) {
          const size = nodes[0].path.length
          this.formData.materialCategoryCode = nodes[0].path[size - 1]
          this.formData.materialCategoryName = nodes[0].label
        } else {
          this.formData.materialCategoryCode = null
          this.formData.materialCategoryName = null
        }
      })
    },
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      let specMaterialList = []
      if (this.isSpec) {
        specMaterialList = this.$refs.materialInfo.getCheckboxRecords()
      }
      this.loadingOpen()
      const params = {
        ...this.formData,
        evgSkuCode: this.evgSkuCode,
        specMaterialList,
      }
      const res = await this.$api
        .ecomEvgSkuMaterialSaveApi({ ...params })
        .catch(() => null)

      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功',
        type: 'success',
      })
      this.close()
    },

    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
